const AUDIO_URL_KEY = 'audioUrlMP3';
const SESSION_ID_KEY = 'verifiedCheckoutSessionId';

export const getStoredAudioUrl = () => localStorage.getItem(AUDIO_URL_KEY) || '';
export const getStoredSessionId = () => localStorage.getItem(SESSION_ID_KEY) || '';

export const storeVerifiedEntitlement = ({ audioUrl, sessionId }) => {
  if (audioUrl) {
    localStorage.setItem(AUDIO_URL_KEY, audioUrl);
  }

  if (sessionId) {
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }
};

export const clearStoredEntitlement = () => {
  localStorage.removeItem(AUDIO_URL_KEY);
  localStorage.removeItem(SESSION_ID_KEY);
};
